import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(HttpBackend) // Carga traducciones desde un backend o archivo remoto
  .use(LanguageDetector) // Detecta automáticamente el idioma del usuario
  .use(initReactI18next) // Integra con React
  .init({
    fallbackLng: 'en', // Idioma predeterminado si no se detecta uno válido
    debug: true,
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json', // Ruta de las traducciones
    },
  });

export default i18n;
